<script setup>
import { computed, ref } from 'vue';
import { getApiRoot } from '~/utilities/api';
import ProfilePage from '~/pages/profile/[id]';

definePageMeta({
  noPadding: true,
  whiteNavbar: true,
});

const route = useRoute();
const username = computed(() => route.params.username);

// Check if a marketplace exists with this slug
const {
  data: marketplace,
  pending: marketplacePending,
  error: marketplaceError,
} = await useFetch(`${getApiRoot()}/gardens/${username.value}`);

// We'll show the marketplace if it exists and has no error
const showMarketplace = computed(() => !marketplacePending.value && marketplace.value && !marketplaceError.value);

// Create a ref to the MarketplaceView component for dynamic title updates
const marketplaceViewRef = ref(null);
</script>

<template>
  <div>
    <!-- Loading state -->
    <div v-if="marketplacePending" class="flex justify-center py-12">
      <LoadingSpinner />
    </div>

    <!-- Show marketplace if one exists with this slug -->
    <GardenView v-else-if="showMarketplace" ref="marketplaceViewRef" :slug="username" />

    <!-- Fallback to profile page -->
    <ProfilePage v-else></ProfilePage>
  </div>
</template>
